import React from 'react';
import './StockCard.css';

const StockCard = ({
  price = 300,
  change = 2.6,
  changePercent = -20,
  logo = "https://stockhero.s3.ap-southeast-1.amazonaws.com/public/coins/AAPL.png",
  name = "Apple Inc.",
  symbol = "AAPL"
}) => {
  const isPositive = change >= 0;
  const colorClass = isPositive ? 'text-success' : 'text-danger';
  const arrow = isPositive ? '↑' : '↓';

  return (
    
      <div className="d-flex align-items-center">
        {/* Logo Section */}
        <div className="me-3">
          <div className="d-flex align-items-center justify-content-center logo-container">
            <img src={logo} alt={name + " Logo"} style={{borderRadius: '50%', width: '100%', height: '100%', objectFit: 'cover'}} onError={(e) => {e.target.style.display='none'}} />
          </div>
        </div>

        {/* Text Section */}
        <div>
          <div className="d-flex align-items-center mb-1">
            <h2 className="stock-logo-name  mb-0 me-2">{name}</h2>
            <span className="badge bg-light text-dark border fw-normal px-2 py-1">{symbol}</span>
          </div>
          
          <div className="d-flex align-items-baseline">
            <h4 className="display-5  mb-0 me-3">${Math.abs(price).toFixed(2)}</h4>
            <div className={`${colorClass} d-flex align-items-center fw-medium`}>
              {/* <span className="me-1">{arrow}</span> */}
              <span>previous trading day’s closed price</span>
            </div>
          </div>
        </div>
      </div>
  );
};

export default StockCard;